import { actionTypes } from "./actions";

export const initialState = {
    UserManualValue: [],
};

const UserManualValueReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USER_MANUAL_GET_REQUEST:
      return {
        ...state,
        isUserManualValueLoading: true,
      };
    case actionTypes.USER_MANUAL_GET_RECEIVE:
      return {
        ...state,
        UserManualValue: action.payload.map((dt, index) => ({ ...dt, id: index })),
        isUserManualValueLoading: false,
      };
    case actionTypes.LIST_TYPE_VALUE_GET_FAIL:
      return {
        ...state,
        isUserManualValueLoading: false,
       
      };
     default:
      return state;
  }
};

export default UserManualValueReducer;
